<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :inline="true" :rules="rules">
        <div class="block">
          <div class="contit">基础信息</div>
          <!-- 选择车牌按钮 -->
          <el-form-item class="item block choose" label="车牌号">
            <el-button size="small" type="primary" @click="showDialog">选择司机</el-button>
            <div class="orderlist" style="margin-top: 15px;">
              <div class="item" v-for="(c, i) in checkedLists" :key="'item' + i">
                <div class="row0">{{ c.driver }}-{{ c.license }}</div>
                <div class="row0">{{ c.tel }}</div>
                <div class="row1" v-for="(p, i) in modalListProps" :key="'item' + i">
                  <div class="col0">{{ p.label }}：</div>
                  <div class="col1">{{ c[p.key] }}</div>
                </div>
              </div>
            </div>
          </el-form-item>
          <!-- 其他控件 -->
          <FormItem
            v-for="(c, i) in formCtrl"
            :key="'formItem' + i"
            :viewMode="c.viewMode"
            :config="c"
            :options="c.options"
            :inputValue="form[c.keyName]"
            @onChange="onChange"
          />
        </div>

        <div class="block">
          <div class="contit">装货信息</div>
          <FormItem
            v-for="(c, i) in formCtrlIn"
            :key="'formItem' + i"
            :viewMode="c.viewMode"
            :config="c"
            :options="c.options"
            :inputValue="form[c.keyName]"
            @onChange="onChange"
            @onInput="onInput"
            @onSelect="onSelect"
          />
        </div>

        <div class="block">
          <div class="contit">卸货信息</div>
          <FormItem
            v-for="(c, i) in formCtrlOut"
            :key="'formItem' + i"
            :viewMode="c.viewMode"
            :config="c"
            :options="c.options"
            :inputValue="form[c.keyName]"
            @onChange="onChange"
            @onInput="onInput"
            @onSelect="onSelect"
          />
        </div>

        <div class="block">
          <div class="contit">运单信息</div>
          <FormItem
            v-for="(c, i) in formCtrlOrder"
            :key="'formItem' + i"
            :viewMode="c.viewMode"
            :config="c"
            :options="c.options"
            :inputValue="form[c.keyName]"
            @onChange="onChange"
          />
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>

    <Dialog class="dialog" ref="dialog" :title="title" @closed="onClose">
      <template #default>
        <el-scrollbar class="content">
          <div class="tit tit1">空闲车辆</div>

          <CarList :labelKey="'license'" :list="modalList" @onCheckChange="onCheckChange" />

          <div class="tit tit2">在途车辆</div>

          <CarList :labelKey="'license'" :list="modalList2" @onCheckChange="onCheckChange" />
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 认</el-button>
          <el-button @click="onModalCancel">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "NonContractOrderDetail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: "order",
      breadcrumb: [
        { name: "订单管理", path: "/order/nocontract" },
        { name: "普通订单", path: "/order/nocontract" },
        { name: "订单添加" }
      ],
      form: {
        cprice: undefined,
        dprice: undefined,
        message: 0,
        nid: undefined,
        shipperid: undefined,
        drman: undefined,
        drtel: undefined,
        coaddress: undefined,
        starttime: undefined,
        enman: undefined,
        ertel: undefined,
        enaddress: undefined,
        ischartcar: 1
      },
      formCtrl: [
        {
          label: "公司单价（元/吨）",
          keyName: "cprice",
          err: "请填写公司单价",
          type: "number"
        },
        {
          label: "司机单价（元/吨）",
          keyName: "dprice",
          err: "请填写司机单价",
          type: "number"
        },
        {
          label: "信息费",
          keyName: "message",
          type: "number"
        },
        {
          label: "货物名称",
          keyName: "nid",
          type: "select",
          err: "请选择货物名称",
          options: []
        },
        {
          label: "客户名称",
          keyName: "shipperid",
          err: "请填写客户名称",
          type: "select",
          options: []
        }
      ],
      // 装货信息
      formCtrlIn: [
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
          options: []
        },
        {
          label: "联系方式",
          keyName: "drtel",
          err: "请填写联系方式",
          type: "text"
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text"
        },
        {
          label: "装货日期",
          keyName: "starttime",
          type: "date"
        }
      ],
      // 卸货信息
      formCtrlOut: [
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text"
        },
        {
          label: "联系方式",
          keyName: "ertel",
          err: "请填写联系方式",
          type: "text"
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text"
        }
      ],
      // 运单信息
      formCtrlOrder: [
        {
          label: "预计结款日期",
          keyName: "repaytime",
          type: "date"
        }
        // {
        //   label: "亏吨协议单价",
        //   keyName: "unitprice",
        //   err: "请填写亏吨协议单价",
        //   type: "number",
        // },
        // {
        //   label: "亏吨协议重量",
        //   keyName: "unitton",
        //   err: "请填写亏吨协议重量",
        //   type: "number",
        // },
      ],
      title: "车辆列表",
      modalList: [],
      modalList2: [],
      checkedIds: [],
      checkedLists: [],
      modalListProps: [
        { label: "预支款", key: "money" },
        { label: "押运员", key: "escort" }
      ],
      fhperson: [],
      shperson: [],
      rules: {
        cprice: [
          { required: true, message: "请填写公司单价", trigger: "blur" }
        ],
        dprice: [
          { required: true, message: "请填写司机单价", trigger: "blur" }
        ],
        message: [{ required: true, message: "请填写信息费", trigger: "blur" }],
        nid: [{ required: true, message: "请选择货物名称", trigger: "blur" }],
        shipperid: [
          { required: true, message: "请填写客户名称", trigger: "blur" }
        ],
        drman: [
          { required: true, message: "请填写装货联系人", trigger: "blur" }
        ],
        drtel: [{ required: true, message: "请填写联系方式", trigger: "blur" }],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" }
        ],
        starttime: [
          { required: true, message: "请选择装货日期", trigger: "blur" }
        ],
        enman: [
          { required: true, message: "请填写卸货联系人", trigger: "blur" }
        ],
        ertel: [{ required: true, message: "请填写联系方式", trigger: "blur" }],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    formOrtherValidate() {
      if (!this.checkedIds.length) {
        this.$message({
          type: "error",
          message: "请选择司机！"
        });
      }
      return this.checkedIds.length;
    },
    onCheckChange(v) {
      // console.log(v)
      // console.log([...this.checkedIds])
      if (v && v.length) {
        this.checkedIds = [...v];
      }
      // console.log([...this.checkedIds])
    },
    onModalSubmit() {
      this.checkedLists = [];
      const modalList = [...this.modalList, ...this.modalList2];
      // console.log(modalList)
      modalList.map(c => {
        if (this.checkedIds.includes(c.license)) {
          if (!c.money.includes("元")) {
            c.money = c.money + "元";
          }
          this.checkedLists.push(c);
        }
      });
      // console.log(this.checkedLists)
      this.form.license = this.checkedIds;
      this.hideDialog();
    },
    onModalCancel() {
      this.form.license = [];
      this.hideDialog();
    },
    onClose() {
      // this.checkedIds = []
      // console.log(this.checkedIds)
    },
    showDialog() {
      this.$refs.dialog && this.$refs.dialog.show();
    },
    hideDialog() {
      this.$refs.dialog && this.$refs.dialog.hide();
    },
    setOptions({ driver, product, custom }) {
      driver.map(v => {
        if (v.isorder == 1) {
          this.modalList.push(v);
        } else {
          this.modalList2.push(v);
        }
      });
      this.formCtrl.map(c => {
        if (c.keyName == "nid" && product.length) {
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.id
            };
          });
        } else if (c.keyName == "shipperid" && custom.length) {
          c.options = custom.map(v => {
            return {
              label: v.name + "-" + v.member,
              value: v.id
            };
          });
        }
      });
    },
    onInput({ key, value }) {
      // console.log(key, value, this.form.shipperid)
      const id = this.form.shipperid;
      if (id && value) {
        this.inputSearch(id, key, value);
      } else if (!value) {
        if (key === "drman") {
          this.formCtrlIn[0]["options"] = [];
          this.form[key] = value;
        } else if (key === "coaddress") {
          this.formCtrlIn[2]["options"] = [];
          this.form[key] = value;
        }
        if (key === "enman") {
          this.formCtrlOut[0]["options"] = [];
          this.form[key] = value;
        }
        if (key === "enaddress") {
          this.formCtrlOut[2]["options"] = [];
          this.form[key] = value;
        }
        this.$forceUpdate();
      }
      // console.log({ ...this.form })
    },
    inputSearch(id, key, value) {
      // console.log(id, key, value)
      let url = `${this.baseUrl}/shippervague`;
      const params = {
        id
      };
      if (key === "drman") {
        params["fhperson"] = value;
      } else if (key === "coaddress") {
        params["fhdizhi"] = value;
      }
      if (key === "enman") {
        params["shperson"] = value;
      }
      if (key === "enaddress") {
        params["shdizhi"] = value;
      } else if (!["drman", "coaddress", "enman", "enaddress"].includes(key)) {
        return;
      }
      // console.log(url, params)
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg === "success" && data) {
            if (key === "drman") {
              this.formCtrlIn[0]["options"] = data.map(v => {
                return {
                  label: v.member,
                  value: v.id,
                  data: v
                };
              });
            } else if (key === "coaddress") {
              this.formCtrlIn[2]["options"] = data.map(v => {
                return {
                  label: v.address,
                  value: v.id,
                  data: v
                };
              });
            }
            if (key === "enman") {
              this.formCtrlOut[0]["options"] = data.map(v => {
                return {
                  label: v.member,
                  value: v.id,
                  data: v
                };
              });
            }
            if (key === "enaddress") {
              this.formCtrlOut[2]["options"] = data.map(v => {
                return {
                  label: v.address,
                  value: v.id,
                  data: v
                };
              });
            }
            this.$forceUpdate();
            // console.log([...this.formCtrlIn])
          }
        },
        err => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！"
          });
        }
      );
    },
    onSelect({ key, value }) {
      // console.log(key, value)
      if (key === "drman") {
        this.formCtrlIn[0]["options"] = [];
        this.form[key] = value["member"];
        this.form["drtel"] = value["phone"];
      } else if (key == "coaddress") {
        this.formCtrlIn[2]["options"] = [];
        this.form[key] = value["address"];
      }
      if (key === "enman") {
        this.formCtrlOut[0]["options"] = [];
        this.form[key] = value["member"];
        this.form["ertel"] = value["phone"];
      }
      if (key === "enaddress") {
        this.formCtrlOut[2]["options"] = [];
        this.form[key] = value["address"];
      }
      this.$forceUpdate();
    }
  },
  mounted() {
    this.getOptions({ userid: this.user.id });
  }
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      &.choose {
        display: flex;

        .el-form-item__content {
          flex: 1;
        }
      }

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 0;
        margin-right: 0;
      }

      .el-input,
      .el-date-editor--daterange {
        width: 300px;
      }

      .el-form-item__content {
        .el-input {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: "关";
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: "开";
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }
    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;
}

.dialog {
  /deep/ .el-dialog {
    width: 931px;
  }

  .content {
    height: 500px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .tit {
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #303133;
    padding-left: 16px;
    position: relative;
    margin: 0 auto 16px;

    &::before {
      position: absolute;
      left: 0;
      top: 5px;
      content: "";
      width: 10px;
      height: 10px;
      background: #67c23a;
      border-radius: 50%;
    }

    &.tit2 {
      &::before {
        background: #f56c6c;
      }
    }
  }

  .btns {
    text-align: center;
    margin-left: 0;
  }
}

.orderlist {
  display: flex;
  flex-wrap: wrap;
  line-height: 20px;

  .item {
    width: 140px;
    margin: 0 15px 15px 0;
    position: relative;
    box-shadow: 0px 0px 8px rgb(0 0 0 / 10%);
    color: #000;
    font-size: 14px;
    padding: 13px 10px;
    border-radius: 2px;

    &:nth-child(8n) {
      margin-right: 0;
    }

    &.is-checked {
      box-shadow: 0px 0px 8px #409eff;
    }

    /deep/ .el-checkbox__input {
      display: none;
    }

    /deep/ .el-checkbox__label {
      padding: 0;
    }

    .row0 {
      display: flex;
      margin: 5px 0;
    }

    .row1 {
      display: flex;
      margin-bottom: 5px;
    }

    .rowlast {
      display: flex;
      border-bottom: 1px solid #eee;
    }
  }
}
</style>
